import { render, staticRenderFns } from "./DelegationImg.vue?vue&type=template&id=ed9ec354&scoped=true"
import script from "./DelegationImg.vue?vue&type=script&lang=js"
export * from "./DelegationImg.vue?vue&type=script&lang=js"
import style0 from "./DelegationImg.vue?vue&type=style&index=0&id=ed9ec354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9ec354",
  null
  
)

export default component.exports